import api from './api';

const salesForceLeadsWithCustomerToken = (payload) => {
  return api.post('/api/submit-leadsv3', null, payload, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    timeout: 80000,
  });
};

const salesForceLeadsWithCustomerTokenV2 = (payload, ver = 'v1') => {
  payload.uniqueID = payload?.phoneNumber;
  return api.post('/api/submit-leads', null, payload, {
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
    timeout: 80000,
  });
};

const salesForceLeads = (payload) => {
  return api.post('customer/v1/salesforce/leadsv3', null, payload, { timeout: 70000 });
};

const salesForceLeadsV2 = (payload) => {
  payload.uniqueID = payload?.phoneNumber;
  return api.post('customer/v1/submit-leads?formId=' + payload?.formId, null, payload, {
    timeout: 70000,
    headers: { 'X-Captcha': payload?.recaptchaToken },
  });
};

const customerVerification = (payload) => {
  return api.post('customer/v1/salesforce/customer-verification', null, payload);
};

const customerVerificationCheck = (payload) => {
  return api.post('customer/v1/saphybris/customers/checking-account', null, payload);
};

const dacChangePhone = (payload) => {
  return api.post('customer/v1/saphybris/customers/change-phone', null, payload);
};

const dacRegister = (payload) => {
  return api.post('customer/v1/saphybris/customers/register', null, payload);
};

const dacCreationAccount = (payload) => {
  return api.post('customer/v1/salesforce/customer-creation-account', null, payload);
};

export default {
  salesForceLeads,
  salesForceLeadsV2,
  salesForceLeadsWithCustomerToken,
  salesForceLeadsWithCustomerTokenV2,
  customerVerification,
  customerVerificationCheck,
  dacChangePhone,
  dacRegister,
  dacCreationAccount,
};
